// Product documentation. The documents themselves come from the API, as written in the administration area.
export const docs = {
    title: 'Documentation',
    description: "User guides and reference documentation for Tristar Advanced Software's products.",
    none: "There's no documentation yet.",
    updated: 'Updated {date}',
    glossaryCard: 'Glossary of synthesizer terms',
    glossaryCardText: 'New to synthesizers? Plain explanations of the words the guides use, from ADSR to waveform.',

    page: {
        all: 'All documentation',
        noDocumentation: 'There is no documentation for this product.',
        title: '{product} documentation',
        // For search results, when the document has no summary of its own.
        summary: 'How to use {product}.',
        contents: 'Contents',
        signInToDownload: 'Sign in to download PDF',
        downloadPdf: 'Download PDF',
        nothingToDownload: "There's nothing to download yet.",
        tooManyPdfs: "You've downloaded a lot of PDFs in the last hour. Please try again later.",
        pdfNotice: "PDF copies are for registered users. Each one is marked with your username and a download ID, so please don't share it.",
        glossary: 'Glossary of synthesizer terms'
    },

    glossary: {
        title: 'Glossary of synthesizer terms',
        description: 'Plain explanations of the synthesizer words used in our guides, for anyone new to sound design.',
        intro: "The words our guides use, explained for beginners. Each entry stands on its own; follow “See also” for related ideas. The best way to learn them is by ear: start from a product's Init preset, change one control at a time, and listen.",
        filter: 'Find a term',
        letters: 'Jump to a letter',
        seeAlso: 'See also:',
        alsoCalled: 'Also called {names}.',
        noMatches: 'No terms match “{query}”.'
    }
};

export type DocsMessages = typeof docs;
